<template>
        <div class="edits setting">
            <div class="setting-h1">
                Deactivate Your Account
            </div>
            <div class="setting-h2" v-if="canAccess('enterprise-my-account')">
                Deactivate your Enterprise Account. All of your data will be removed from the general public. 
            </div>
             <div class="setting-h2" v-else>
                Deactivate your Job Seeker Account.
            </div>
        <form> 
         <div class="form-buttons mb-3">
                <button @click.prevent="openModal" :disabled="loading" class="btn btn-default primary-btn" style="background-color:var(--red)!important;color:white;">
                    {{ loading == true ? 'Deactivating...':'Deactivate Account' }}
                </button>
            </div>
           
        </form>
        <SystemMessage v-if="!loading && error" message="Unable to deactivate your account. Please try again later"/>
        <WarningOptionsModal
            ref="delAccModal"
            :body="this.delAccModal.body"
            :title="this.delAccModal.title"
            :close-modal="this.closeModal"
            :yes-selected="this.deleteAccount"
            :yes-button-label="this.delAccModal.yesButtonLabel"
            :no-button-label="this.delAccModal.noButtonLabel"
            :modal-id="this.delAccModal.modalId"
            loading-button-label="Deleting All Vacancies..."
            />
        <!-- <LoadingIndicator/> -->
        </div>
</template>
<script>
import { canAccess as authCanAccess } from '@/services/authService';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import SystemMessage from '@/components/Utility/SystemMessage.vue';
import WarningOptionsModal from '@/components/modals/WarningOptionsModal.vue';
import { deactivateAccountAsync } from '@/services/accountService';

export default {
    components:{
        LoadingIndicator, LoadingIndicator, SystemMessage, WarningOptionsModal
    },
    data(){
        return{
             delAccModal:{
                title:"Deactivate Account",
                body:"<p><b>WARNING</b><br/>You are about to deactivate your account. Please note that you can still come back and reactivate it by logging within a 90-day period. Beyond that, your account will be permanently deleted.<p/><p>Are you sure you want to deactivate your account?</p>",
                modalId:"delAllVac",
                yesButtonLabel:"Deactive Account",
                noButtonLabel:"Cancel"
            },
            loading: false,
            error: false
        }
    },
    methods:{
        canAccess(path){
            return authCanAccess(path);
        },
        openModal(){
            this.$refs.delAccModal.show();
        },
        async deleteAccount(){
            try{
                this.$refs.delAccModal.hide();
                this.loading = true;
                this.error = false;
                var response = await deactivateAccountAsync();
                if(!response.success){
                    let err = new Error();
                    throw err;
                }else{
                    this.$store.dispatch('auth/logout');
                    this.$router.push({path:'/login',
                                    query:{
                                        message:"Your account has been deactivated"
                                    }
                    });
                }
            }catch(e){
                this.loading = false;
                this.error = true;
            }
            
        },
        closeModal(){
            this.$refs.delAccModal.hide();
        }
        
    }
}
</script>
<style scoped>

.setting-h1{
    color:var(--red);
}

.edit-profile{
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    margin:4.5rem 0rem;
}

.edits{
    grid-column:2/3;
}

    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}

select{
    min-width:9rem;
}

@media (max-width:768px) {
    .edits{
    grid-column:1/4;
    margin:0rem 0.8rem;
}
}
</style>